import { motion, useReducedMotion, type HTMLMotionProps } from "motion/react";
import type { ReactNode } from "react";

export function MotionButton({ children, className = "", ...props }: HTMLMotionProps<"button"> & { children: ReactNode }) {
  const reduced = useReducedMotion();
  return (
    <motion.button
      whileHover={reduced || props.disabled ? undefined : { y: -1 }}
      whileTap={reduced || props.disabled ? undefined : { scale: 0.98 }}
      transition={{ duration: 0.16 }}
      className={`button ${className}`}
      {...props}
    >
      {children}
    </motion.button>
  );
}
